
class MyFormHandler {
    constructor() {
        this.input = document.querySelector(".js-qty__num");
        this.buttonMinus = document.querySelector('.js-qty__adjust--minus');
        this.buttonPlus = document.querySelector('.js-qty__adjust--plus');
        this.details = document.querySelectorAll('.details');
        this._form = document.querySelectorAll('form')[2];
        this._select = this._form.children[2].children[0].children;
        this._option = document.querySelector('.option');
        this.skip = document.querySelector(".skip").innerHTML;
        // skip 0,1,2 こんな感じで記載

        this._n = 10;
        var getn = document.querySelector('.option .initval');
        if (getn != null) {
            this._n = Number(getn.innerHTML);
        }

        this.initialize();
    }

    checkInputValue() {
        let value = parseInt(this.input.value, 10);
        if (isNaN(value) || value < this._n) {
            this.input.value = String(this._n);
        } else if (value > 9999) {
            this.input.value = String(9999);
        }
    }

    initialize() {
        this.input.value = String(this._n);

        // イベントリスナーの設定
        this.input.addEventListener('change', this.checkInputValue.bind(this));
        this.buttonPlus.addEventListener('click', this.onPlusClick.bind(this));
        this.buttonMinus.addEventListener('click', this.onMinusClick.bind(this));
        let button = this._form.querySelector('button');
      　button.addEventListener('click', this.onSubmit.bind(this));
        

        this.details.forEach(element => {
            const summary = element.querySelector('.details__summary');
            const content = element.querySelector('.details__content');
            summary.addEventListener('click', (e) => this.onSummaryClick(e, element, content));
        });
    }

    onPlusClick() {
        this.checkInputValue();
    }

    onMinusClick() {
        this.checkInputValue();
    }

    onSummaryClick(e, element, content) {
        e.preventDefault();
    
        if (element.open) {
            const openDetails = content.animate(
                {
                    opacity: [1, 0],
                    height: [content.offsetHeight + 'px', 0],
                },
                {
                    duration: 360,
                    easing: 'ease-out',
                }
            );
    
            openDetails.onfinish = () => {
                element.removeAttribute('open');
            };
        } else {
            element.setAttribute('open', 'true');
            const openDetails = content.animate(
                {
                    opacity: [0, 1],
                    height: [0, content.offsetHeight + 'px'],
                },
                {
                    duration: 360,
                    easing: 'ease-out',
                }
            );
        }
        
    }

    onSubmit(event) {
        var _end = false;
        let _key = "";
        let _lastsave = 0;
        let _save = 0;

        for (var i = 0; i < this._select.length; i ++) {
            
            if (this.skip != "") {

              if (this.skip.indexOf(",", _save) != -1) {
                  _lastsave = _save;
                  _save = this.skip.indexOf(",", _lastsave) + 1;
                  _key = this.skip.substring(_lastsave, _save - 1);
              } else {
                  if (_save == 0) {
                    _key = this.skip;
                  } else {
                    _key = this.skip.substring(_save, 999);
                  }
              }
              
            }
            if (i + 1 == _key){ continue; }

            if (!_end) {
              var _check = this._select[i].children[1].selectedIndex;
              if (_check != 1) {
                  event.preventDefault();
                
                  var _text = "確認をお願いします。";
                  if (isNaN(this._option)) {
                    if (this._option.children.length >= i + 1) {
                      _text = this._option.children[i].innerHTML;
                    }
                  }
                
                  alert(_text);
                  _end = true;
                　return;
              }       
            } else {
                break;
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {new MyFormHandler();});